import { render, staticRenderFns } from "./salaryTongcheng.vue?vue&type=template&id=d5b1094e&scoped=true&"
import script from "./salaryTongcheng.vue?vue&type=script&lang=js&"
export * from "./salaryTongcheng.vue?vue&type=script&lang=js&"
import style0 from "./salaryTongcheng.vue?vue&type=style&index=0&id=d5b1094e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b1094e",
  null
  
)

export default component.exports